import { DocumentList } from "./Estimates";

export default function PurchaseOrders() {
  return <DocumentList type="po" />;
}
